import { useRequest } from 'ahooks'
import { requestCommon } from 'live/lib/utils'
import React, { useCallback, useState } from 'react'
import UpdatesModal from './UpdatesModal'

interface VersionInfoProps {
    instance: { id: number; type: string }
}

const typeMap: Record<string, string> = {
    dashboard: 'DASHBOARD',
    'pipes-module': 'PIPES_MODULE',
    datasource: 'DATASOURCE',
    'lookup-table': 'LOOKUP_TABLE',
    'css-snippet': 'CSS_SNIPPET',
    'groovy-snippet': 'GROOVY_SNIPPET',
    'js-snippet': 'JS_SNIPPET',
    rule: 'RULE'
}

const VersionInfo: React.VFC<VersionInfoProps> = ({ instance }) => {
    const [show, setShow] = useState(false)
    const showModal = useCallback((event: React.MouseEvent) => {
        event.preventDefault()
        setShow(true)
    }, [])
    const hideModal = useCallback(() => {
        setShow(false)
    }, [])

    const { data: featureData } = useRequest(async () => {
        const response = await fetch(
            `/services/plugin-package-manager/installed/feature?entityType=${
                typeMap[instance.type] ?? instance.type
            }&entityKey=${instance.id}`,
            { ...requestCommon }
        )

        if (!response.ok) {
            return null
        }

        return response.json()
    })

    if (!featureData) {
        return null
    }

    return (
        <>
            &nbsp;
            <a href="#" onClick={showModal}>
                v{featureData.version}
            </a>
            {show && (
                <UpdatesModal show packageId={featureData.packageId} openItemId={featureData.uuid} onHide={hideModal} />
            )}
        </>
    )
}

export default VersionInfo
